import { useEffect, useState } from "react";
// import { FaSearch } from "react-icons/fa";
import AdminLayout from "../../layouts/AdminLayout";
import "./ManageGyms.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import companyLogo from "../../assets/images/gymfitorangelogo22.png";
import {
  getAllGyms,
  approveGym,
  rejectGym,
  getGymMembers,
} from "../../services/gymService";

export default function ManageGyms() {
  const [gyms, setGyms] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    loadGyms();
  }, []);

  const loadGyms = async () => {
    const data = await getAllGyms();
    setGyms(data);
  };

  const handleApprove = async (id) => {
    await approveGym(id);
    loadGyms();
  };

  const handleReject = async (id) => {
    await rejectGym(id);
    loadGyms();
  };

  const downloadGymMembers = async (gym) => {
    try {
      const members = await getGymMembers(gym.id);

      const doc = new jsPDF("p", "mm", "a4");

      const pageWidth = doc.internal.pageSize.getWidth();

      // Logo
      doc.addImage(companyLogo, "PNG", 15, 10, 28, 28);

      // Company Name
      doc.setFontSize(20);
      doc.setTextColor(230, 120, 20);
      doc.text("NN AI Solutions", pageWidth / 2, 18, {
        align: "center",
      });

      doc.setFontSize(12);
      doc.setTextColor(120);

      doc.text("Where AI Meets Innovation", pageWidth / 2, 26, {
        align: "center",
      });

      // Report Title

      doc.setDrawColor(230, 120, 20);
      doc.line(15, 42, 195, 42);

      doc.setFontSize(18);
      doc.setTextColor(0);

      doc.text("Gym Report", pageWidth / 2, 55, {
        align: "center",
      });

      doc.setFontSize(11);

      doc.text(
        `Generated on : ${new Date().toLocaleString()}`,
        pageWidth / 2,
        64,
        {
          align: "center",
        },
      );

      doc.setFontSize(16);

      doc.text("Gym Information", 15, 82);

      doc.setFontSize(11);

      let y = 92;

      const info = [
        ["Gym Name", gym.gymName],
        ["Owner", gym.ownerName],
        ["Email", gym.email],
        ["Phone", gym.phone],
        ["Registration", gym.registrationType],
        ["Subscription", gym.subscriptionPlan || "No Plan"],
        ["Payment Status", gym.paymentStatus],
        ["Subscription Status", gym.subscriptionStatus],
        ["Total Members", members.length],
        ["Total Trainers", gym.totalTrainers],
        ["Days Left", gym.daysLeft],
      ];

      info.forEach((item) => {
        doc.text(`${item[0]} :`, 18, y);
        doc.text(String(item[1] || "-"), 75, y);
        y += 8;
      });

      doc.addPage();
      doc.setFontSize(18);

      doc.text("Members List", 15, 20);

      autoTable(doc, {
        startY: 30,

        head: [
          [
            "#",
            "Member",
            "Phone",
            "Plan",
            "Trainer",
            "Join Date",
            "Expiry",
            "Status",
          ],
        ],

        body: members.map((member, index) => [
          index + 1,
          member.fullName || "-",
          member.phone || "-",
          member.membershipPlan || "-",
          member.trainerName || "-",
          member.joinDate || "-",
          member.expiryDate || "-",
          member.status || "-",
        ]),

        theme: "grid",

        headStyles: {
          fillColor: [230, 120, 20],
        },

        styles: {
          fontSize: 8,
        },
      });

      const pages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= pages; i++) {
        doc.setPage(i);

        doc.setDrawColor(220);
        doc.line(15, 287, 195, 287);

        doc.setFontSize(10);

        doc.text("Powered By NN AI Solutions", 15, 293);

        doc.text(`Page ${i} of ${pages}`, 170, 293);
      }

      doc.save(`${gym.gymName}-Report.pdf`);
    } catch (error) {
      console.error(error);
      alert("Failed to download PDF");
    }
  };

  // const filteredGyms = gyms.filter(
  //   (gym) =>
  //     gym.gymName?.toLowerCase().includes(search.toLowerCase()) ||
  //     gym.ownerName?.toLowerCase().includes(search.toLowerCase()) ||
  //     gym.email?.toLowerCase().includes(search.toLowerCase()),
  // );

  const filteredGyms = gyms.filter((gym) => {
    const matchesSearch =
      gym.gymName?.toLowerCase().includes(search.toLowerCase()) ||
      gym.ownerName?.toLowerCase().includes(search.toLowerCase()) ||
      gym.email?.toLowerCase().includes(search.toLowerCase());

    let matchesFilter = true;

    switch (filter) {
      case "Pending":
        matchesFilter = gym.status === "Pending";
        break;

      case "Approved":
        matchesFilter = gym.status === "Approved";
        break;

      case "Rejected":
        matchesFilter = gym.status === "Rejected";
        break;

      case "Trial":
        matchesFilter = gym.registrationType === "trial";
        break;

      case "Paid":
        matchesFilter = gym.registrationType === "paid";
        break;

      case "Active":
        matchesFilter = gym.subscriptionStatus === "Active";
        break;

      case "Expired":
        matchesFilter = gym.subscriptionStatus === "Expired";
        break;

      default:
        matchesFilter = true;
    }

    return matchesSearch && matchesFilter;
  });

  const formatLastLogin = (lastLogin) => {
    if (!lastLogin) return "-";

    const now = new Date();
    const login = new Date(lastLogin);

    const diff = Math.floor((now - login) / 1000);

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hrs ago`;
    if (diff < 172800) return "Yesterday";

    return `${Math.floor(diff / 86400)} days ago`;
  };

  const downloadAllGymOwners = async () => {
    try {
      const doc = new jsPDF("p", "mm", "a4");

      const pageWidth = doc.internal.pageSize.getWidth();

      // Logo
      doc.addImage(companyLogo, "PNG", 15, 10, 25, 25);

      doc.setFontSize(22);
      doc.setTextColor(230, 120, 20);
      doc.text("NN AI Solutions", pageWidth / 2, 18, {
        align: "center",
      });

      doc.setFontSize(12);
      doc.setTextColor(100);
      doc.text("Complete Gym Owners Report", pageWidth / 2, 28, {
        align: "center",
      });

      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 36, {
        align: "center",
      });

      autoTable(doc, {
        startY: 50,

        head: [
          [
            "#",
            "Gym Name",
            "Owner",
            "Phone",
            "Email",
            "Registration",
            "Plan",
            "Subscription",
            "Status",
            "Members",
            "Trainers",
          ],
        ],

        body: gyms.map((gym, index) => [
          index + 1,
          gym.gymName || "-",
          gym.ownerName || "-",
          gym.phone || "-",
          gym.email || "-",
          gym.registrationType || "-",
          gym.subscriptionPlan || "-",
          gym.subscriptionStatus || "-",
          gym.status || "-",
          gym.totalMembers || 0,
          gym.totalTrainers || 0,
        ]),

        theme: "grid",

        headStyles: {
          fillColor: [230, 120, 20],
          textColor: 255,
        },

        styles: {
          fontSize: 8,
        },
      });

      const pages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= pages; i++) {
        doc.setPage(i);

        doc.setFontSize(10);

        doc.text("Powered By NN AI Solutions", 15, 292);

        doc.text(`Page ${i} of ${pages}`, 170, 292);
      }

      doc.save("All_Gym_Owners_Report.pdf");
    } catch (error) {
      console.error(error);
      alert("Failed to generate PDF");
    }
  };

  return (
    <AdminLayout>
      <div className="main-contain">
        <div className="manage-header">
          <button className="download-all-btn" onClick={downloadAllGymOwners}>
            Download All Owners PDF
          </button>
          <div>
            <h1>Manage Gyms</h1>
            <p>Approve, reject and monitor gym subscriptions.</p>
          </div>

          <div className="search-container">
            {/* <FaSearch className="search-icon" /> */}

            <input
              type="text"
              placeholder="Search Gym..."
              className="search-box"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="filter-buttons">
          {[
            "All",
            "Pending",
            "Approved",
            "Rejected",
            "Trial",
            "Paid",
            "Active",
            "Expired",
          ].map((item) => (
            <button
              key={item}
              className={`filter-btn ${filter === item ? "active-filter" : ""}`}
              onClick={() => setFilter(item)}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="table-wrapper">
          <table className="member-table">
            <thead>
              <tr>
                <th>Gym Name</th>
                <th>Owner</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Status</th>
                <th>Registration</th>
                <th>Payment</th>
                <th>Subscription</th>
                <th>Plan</th>
                <th>Days Left</th>
                <th>Members</th>
                <th>Trainers</th>
                <th>Storage</th>
                <th>Last Login</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredGyms.length > 0 ? (
                filteredGyms.map((gym) => (
                  <tr key={gym.id}>
                    <td>{gym.gymName}</td>

                    <td>{gym.ownerName}</td>
                    <td>{gym.phone || "-"}</td>

                    <td>{gym.email}</td>

                    <td>
                      <span
                        className={
                          gym.status === "Approved"
                            ? "status-approved"
                            : gym.status === "Rejected"
                              ? "status-rejected"
                              : "status-pending"
                        }
                      >
                        {gym.status}
                      </span>
                    </td>

                    {/* Registration Type */}

                    <td>
                      {gym.registrationType === "trial" ? (
                        <span className="trial-badge"> Free Trial</span>
                      ) : (
                        <span className="paid-badge"> Paid</span>
                      )}
                    </td>
                    <td>
                      <span
                        className={
                          gym.paymentStatus === "Paid"
                            ? "payment-paid"
                            : gym.paymentStatus === "Pending"
                              ? "payment-pending"
                              : "payment-trial"
                        }
                      >
                        {gym.paymentStatus || "Trial"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={
                          gym.subscriptionStatus === "Active"
                            ? "subscription-active"
                            : "subscription-expired"
                        }
                      >
                        {gym.subscriptionStatus || "Inactive"}
                      </span>
                    </td>

                    {/* Subscription Plan */}

                    <td>
                      {gym.subscriptionPlan ? (
                        <span className="plan-badge">
                          {gym.subscriptionPlan}
                          {gym.subscriptionDuration
                            ? ` (${gym.subscriptionDuration})`
                            : ""}
                        </span>
                      ) : (
                        <span className="no-plan">No Plan</span>
                      )}
                    </td>

                    <td>
                      {gym.daysLeft > 0 ? (
                        <span className="days-left">{gym.daysLeft} Days</span>
                      ) : (
                        <span className="expired-days">Expired</span>
                      )}
                    </td>
                    <td>{gym.totalMembers}</td>
                    <td>{gym.totalTrainers}</td>
                    <td>
                      {(() => {
                        const used = Number(gym.storageUsed || 0);
                        const limit = Number(gym.storageLimit || 0);

                        const usedMB = used / (1024 * 1024);
                        const percentage =
                          limit > 0 ? (usedMB / limit) * 100 : 0;

                        return (
                          <div className="storage-cell">
                            <div className="storage-bar">
                              <div
                                className={`storage-fill ${
                                  percentage >= 90
                                    ? "danger"
                                    : percentage >= 70
                                      ? "warning"
                                      : "success"
                                }`}
                                style={{
                                  width: `${Math.min(percentage, 100)}%`,
                                }}
                              />
                            </div>

                            <small>
                              {usedMB.toFixed(2)} MB / {limit} MB
                            </small>
                          </div>
                        );
                      })()}
                    </td>
                    <td>{formatLastLogin(gym.lastLogin)}</td>

                    <td className="action-buttons">
                      <button
                        className="approve-btn"
                        disabled={gym.status === "Approved"}
                        onClick={() => handleApprove(gym.id)}
                      >
                        {gym.status === "Approved" ? "Approved" : "Approve"}
                      </button>

                      <button
                        className="reject-btn"
                        onClick={() => handleReject(gym.id)}
                      >
                        Reject
                      </button>

                      <button
                        className="download-btn"
                        onClick={() => downloadGymMembers(gym)}
                      >
                        Download Members
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No gyms found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
